import script from "./_pp-ticket-check.vue?vue&type=script&setup=true&lang=ts"
export * from "./_pp-ticket-check.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__